/**
 * Preview lookbook: catalog is rendered by Liquid into #previewCatalogJson.
 * Arrows step images, then the next preview product.
 */
(function () {
  let previewCatalog = [];
  let lbProductIdx = 0;
  let lbImageIdx = 0;

  function placeholderImg() {
    const onDark = document.documentElement.getAttribute("data-theme") === "dark";
    const o = window.QLEX_LOGOS || window.QLEX?.logos;
    if (o) return onDark ? o.qlexDark : o.qlexLight;
    return "";
  }

  function getImages(p) {
    if (!p?.images) return [];
    return p.images.filter((n) => n?.url);
  }

  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;");
  }

  function getLightboxEls() {
    return {
      root: document.getElementById("previewLightbox"),
      overlay: document.getElementById("previewLightboxOverlay"),
      img: document.getElementById("previewLightboxImg"),
      closeBtn: document.getElementById("previewLightboxClose"),
      prevBtn: document.getElementById("previewLightboxPrev"),
      nextBtn: document.getElementById("previewLightboxNext"),
    };
  }

  function showLightboxUI(show) {
    const { root, overlay } = getLightboxEls();
    if (!root || !overlay) return;
    if (show) {
      root.hidden = false;
      overlay.hidden = false;
      root.setAttribute("aria-hidden", "false");
      overlay.setAttribute("aria-hidden", "false");
      root.classList.add("is-open");
      overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
    } else {
      root.classList.remove("is-open");
      overlay.classList.remove("is-open");
      root.hidden = true;
      overlay.hidden = true;
      root.setAttribute("aria-hidden", "true");
      overlay.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
  }

  function updateLightboxImage() {
    const { img, prevBtn, nextBtn } = getLightboxEls();
    const p = previewCatalog[lbProductIdx];
    if (!p || !img) return;
    const imgs = getImages(p);
    const nProducts = previewCatalog.length;
    const canStep = nProducts > 1 || imgs.length > 1;
    if (imgs.length === 0) {
      img.src = placeholderImg();
      img.alt = p.title || "Preview";
      if (prevBtn) prevBtn.hidden = !canStep;
      if (nextBtn) nextBtn.hidden = !canStep;
      return;
    }
    if (lbImageIdx >= imgs.length) lbImageIdx = 0;
    if (lbImageIdx < 0) lbImageIdx = imgs.length - 1;
    img.src = imgs[lbImageIdx].url;
    img.alt = imgs[lbImageIdx].alt || p.title || "Preview";
    if (prevBtn) prevBtn.hidden = !canStep;
    if (nextBtn) nextBtn.hidden = !canStep;
  }

  function openLightbox(productIdx) {
    lbProductIdx = productIdx;
    lbImageIdx = 0;
    if (!previewCatalog[lbProductIdx]) return;
    showLightboxUI(true);
    updateLightboxImage();
    getLightboxEls().closeBtn?.focus();
  }

  function lightboxNext() {
    const n = previewCatalog.length;
    if (n === 0) return;
    const imgs = getImages(previewCatalog[lbProductIdx]);
    if (imgs.length > 1 && lbImageIdx < imgs.length - 1) {
      lbImageIdx += 1;
      updateLightboxImage();
      return;
    }
    if (n > 1) {
      lbProductIdx = (lbProductIdx + 1) % n;
      lbImageIdx = 0;
      updateLightboxImage();
    } else if (imgs.length > 1) {
      lbImageIdx = (lbImageIdx + 1) % imgs.length;
      updateLightboxImage();
    }
  }

  function lightboxPrev() {
    const n = previewCatalog.length;
    if (n === 0) return;
    const imgs = getImages(previewCatalog[lbProductIdx]);
    if (imgs.length > 1 && lbImageIdx > 0) {
      lbImageIdx -= 1;
      updateLightboxImage();
      return;
    }
    if (n > 1) {
      lbProductIdx = (lbProductIdx - 1 + n) % n;
      const prevImgs = getImages(previewCatalog[lbProductIdx]);
      lbImageIdx = prevImgs.length > 0 ? prevImgs.length - 1 : 0;
      updateLightboxImage();
    } else if (imgs.length > 1) {
      lbImageIdx = (lbImageIdx - 1 + imgs.length) % imgs.length;
      updateLightboxImage();
    }
  }

  function bindLightbox() {
    const { overlay, closeBtn, prevBtn, nextBtn } = getLightboxEls();
    closeBtn?.addEventListener("click", () => showLightboxUI(false));
    overlay?.addEventListener("click", () => showLightboxUI(false));
    prevBtn?.addEventListener("click", (e) => { e.stopPropagation(); lightboxPrev(); });
    nextBtn?.addEventListener("click", (e) => { e.stopPropagation(); lightboxNext(); });
    document.addEventListener("keydown", (e) => {
      const lb = document.getElementById("previewLightbox");
      if (!lb || lb.hidden) return;
      if (e.key === "Escape") {
        e.preventDefault();
        showLightboxUI(false);
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        lightboxNext();
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        lightboxPrev();
      }
    });
  }

  function renderGrid() {
    const ul = document.getElementById("previewGrid");
    const empty = document.getElementById("previewEmpty");
    if (!ul) return;
    if (!previewCatalog.length) {
      ul.innerHTML = "";
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    ul.innerHTML = previewCatalog
      .map((p, idx) => {
        const first = getImages(p)[0];
        const src = first?.url || placeholderImg();
        const alt = first?.alt || p.title || "Preview";
        return `<li class="preview-tile">
  <button type="button" class="preview-tile-open" data-preview-idx="${idx}" aria-label="View larger image">
    <span class="preview-tile-inner"><img src="${escapeAttr(src)}" alt="${escapeAttr(alt)}" loading="lazy" width="400" height="400"></span>
  </button>
</li>`;
      })
      .join("");
    ul.addEventListener("click", (e) => {
      const b = e.target.closest(".preview-tile-open");
      if (!b) return;
      e.preventDefault();
      openLightbox(parseInt(b.dataset.previewIdx, 10));
    });
  }

  function tickClock() {
    const el = document.getElementById("previewTimestamp");
    if (!el) return;
    const d = new Date();
    const s = d.toLocaleString("en-US", {
      timeZone: "America/Chicago",
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
    el.textContent = s.replace(",", "") + " Chicago";
  }

  function init() {
    bindLightbox();
    const raw = document.getElementById("previewCatalogJson");
    if (raw) {
      try {
        previewCatalog = JSON.parse(raw.textContent.trim() || "[]");
        if (!Array.isArray(previewCatalog)) previewCatalog = [];
      } catch (err) {
        console.error(err);
        previewCatalog = [];
      }
    }
    renderGrid();
    tickClock();
    setInterval(tickClock, 1000);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
